import { Locale } from '@silae/composables';

export function formatLocale(locale: Locale) {
	if (!locale) {
		return 'fr-FR';
	}

	const { value, ISO } = locale;
	const iso = ISO ?? value?.toUpperCase();

	return `${value}-${iso}`;
}
